import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const SITE_ORIGIN = 'https://staycoolairco.nl';

// Default og:url (zelfde afleiding als canonical in MetaTags); pagina-Helmets met eigen og:url registreren later en winnen.
export default function DefaultOgUrl() {
  const { pathname } = useLocation();

  return (
    <Helmet>
      <meta property="og:url" content={`${SITE_ORIGIN}${pathname}`} />
    </Helmet>
  );
}
